import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=3d77efe5&scoped=true&"
import script from "./Phone.vue?vue&type=script&lang=ts&"
export * from "./Phone.vue?vue&type=script&lang=ts&"
import style0 from "./Phone.vue?vue&type=style&index=0&id=3d77efe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d77efe5",
  null
  
)

export default component.exports